<ndt-schedule-register-view
   [schedulePrivileges]="schedulePrivileges$ | async"
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   (create)="onCreate()"
   [columns]="columns"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   (selectedId)="handleSelectedId($event)"
   (saveScheduleAs)="onScheduleSaveAs($event)"
>
</ndt-schedule-register-view>
